import { getRetinaSrcs, imageUrl } from '@helpers/image';
import SvgChevron from '@img/icons/menu-chevron-right.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './InformationCard.styles';
const InformationCard = (props) => {
    return (React.createElement(S.Outer, { "data-site": props.site },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Container, { ...(props.cta
                    ? {
                        as: 'a',
                        href: props.cta.url,
                        target: props.cta.target,
                        'aria-label': props.cta.text,
                    }
                    : {}) },
                React.createElement(S.Title, null,
                    props.icon && (React.createElement(S.IconWrapper, null,
                        React.createElement(S.Icon, { src: imageUrl(props.icon, { width: 45 }, props.site), srcSet: getRetinaSrcs(props.icon, 45, props.site).join(','), role: "presentation", loading: "lazy" }))),
                    props.title),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
                props.site !== 'mep' && (React.createElement(S.ChevronIcon, null,
                    React.createElement(SvgChevron, null)))))));
};
export default InformationCard;
